var _rect, _circle, _rect2, _rect3, _text, _text2, _text3, _circle2, _path, _path2, _rect4, _text4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAyuraBloom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 750",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 750,
    fill: "#dce9d5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 980,
    cy: 140,
    r: 210,
    fill: "#b7d19e"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 1060,
    height: 610,
    rx: 26,
    fill: "#fffaf0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 1060,
    height: 82,
    rx: 26,
    fill: "#376342"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 120,
    fontFamily: "Arial",
    fontSize: 28,
    fontWeight: 700,
    fill: "#fff"
  }, "AYURA BLOOM")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 245,
    fontFamily: "Georgia",
    fontSize: 60,
    fontWeight: 700,
    fill: "#294d35"
  }, "Care, rooted in nature.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 295,
    fontFamily: "Arial",
    fontSize: 23,
    fill: "#617461"
  }, "Natural wellness for everyday living.")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 925,
    cy: 355,
    r: 150,
    fill: "#e9c98d"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M925 485c-70-95-98-156-4-250 94 94 66 155 4 250Z",
    fill: "#5c884f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M925 485c70-95 98-156 4-250",
    fill: "none",
    stroke: "#376342",
    strokeWidth: 9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 400,
    width: 230,
    height: 58,
    rx: 29,
    fill: "#d27d42"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 165,
    y: 437,
    fontFamily: "Arial",
    fontSize: 20,
    fontWeight: 700,
    fill: "#fff"
  }, "Explore care")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 530,
    width: 250,
    height: 64,
    rx: 12,
    fill: "#e4efdf"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 530,
    width: 250,
    height: 64,
    rx: 12,
    fill: "#e4efdf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAyuraBloom);
export default __webpack_public_path__ + "static/media/ayura-bloom.969eb6d74a9b9aaa8890413aecb3f6ce.svg";
export { ForwardRef as ReactComponent };